import { AdminAppLink } from '@app/models/api';
import { AdminSectionName } from '@app/enumerations';

interface AdminNavigationConfigParameters {
    adminUrl: string;
    catcoverageDomain: string;
    rootUrl: string;
    securedUrl: string;
}

const AdminNavigationConfig = (params: AdminNavigationConfigParameters): AdminAppLink[] => {
        return [
            {
                id: 'accounting-title',
                label: 'Accounting',
                isRouter: false,
                subLinks: [
                    {
                        id: 'policyCommissionPayouts-subtitle',
                        label: 'Policy Commission Payouts (3 Steps)',
                        isRouter: false,
                        subLinks: [
                            {
                                id: 'accountingPolicies',
                                label: 'Verify Policy Payments (Daily)',
                                url: `${params.catcoverageDomain}/admin_accounting_policies.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'accountingMonthly',

                                label: 'Finalize Revenue Statements (Monthly)',
                                url: `${params.catcoverageDomain}/admin_accounting_monthly.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'accountingBatches',

                                label: 'Revenue Statements Batches',
                                url: `${params.catcoverageDomain}/admin_accounting_batches.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'accountingCommissions',

                                label: 'Approve Commissions Payout (As needed)',
                                url: `${params.catcoverageDomain}/admin_accounting_commissions.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'accountingSurplus',

                                label: 'Approve Surplus Payouts (As needed)',
                                url: `${params.catcoverageDomain}/admin_accounting_surplus.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'accountingRbc',

                                label: 'Authorize Rebates and Create RBC batch (As needed)',
                                url: `${params.catcoverageDomain}/admin_accounting_rbc.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'accountingSurplusBatches',

                                label: 'Surplus Line Filing',
                                url: `${params.catcoverageDomain}/admin_accounting_surplusbatches.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                        ]
                    },
                    {
                        id: 'bankDeposits-subtitle',
                        label: 'Bank Deposits',
                        isRouter: false,
                        subLinks: [
                            {
                                id: 'offlineBankDeposit',

                                label: 'Offline Bank Deposits',
                                url: `${params.catcoverageDomain}/admin_bankdeposit.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'pbcDeposit',

                                label: 'ACH Bank Deposits',
                                url: `${params.catcoverageDomain}/admin_pbcdeposit.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'offlinePayments',

                                label: 'Offline Payment Batches',
                                url: `${params.catcoverageDomain}/admin_offlinePayments.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                        ]
                    },
                    
                ]
            },
            {
                id: 'admin-title',
                label: 'Admin',
                isRouter: false,
                subLinks: [
                    {
                        id: 'adminLinks-subtitle',
                        label: 'Admin Links',
                        isRouter: false,
                        subLinks: [
                            {
                                id: 'emails',
                                label: 'Emails',
                                url: `${params.catcoverageDomain}/admin_emails.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'adminUsers',
                                label: 'Admin Users',
                                url: `${params.catcoverageDomain}/admin_users.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'states',
                                label: 'State Surplus Text',
                                url: `${params.catcoverageDomain}/admin_states.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'stateTax',
                                label: 'State Tax Rates',
                                url: `${params.catcoverageDomain}/admin_state_tax.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'userAuth',
                                label: 'User/Group Page Access',
                                url: `${params.catcoverageDomain}/admin_user_auth.aspx`,
                                isRouter: false,
                                subLinks: []
                            }
                        ]
                    },
                    {
                        id: 'management-subtitle',
                        label: 'Management',
                        isRouter: false,
                        subLinks: [
                            {
                                id: 'claimsLossEmailRecipients',
                                label: 'Admin Loss Submital Email Management',
                                url: `${params.catcoverageDomain}/admin_claims_loss_email_recipients.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'nonRenewal',
                                label: 'Admin Non-Renewals',
                                url: `${params.catcoverageDomain}/admin_nonRenewalBatches.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'renewalBindingAuthorities',
                                label: 'Admin Renewal Binding Authorities',
                                url: `${params.catcoverageDomain}/admin_renewalBindingAuthorities.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'renewalRates',
                                label: 'Admin Renewal Rates',
                                url: `${params.catcoverageDomain}/admin_renewalRates.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'aggregateReport',
                                label: 'Aggregate Report',
                                url: `${params.catcoverageDomain}/admin_aggregate_report.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'baaMinimumAllowedRates',
                                label: 'BAA Minimum Allowed Rates Management',
                                url: `${params.catcoverageDomain}/admin_baa_minimum_allowed_rates.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'baaRatingMethods',
                                label: 'BAA Rating Methods Management',
                                url: `${params.catcoverageDomain}/admin_baa_rating_methods.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'baaTermsManagement',
                                label: 'BA Aggregate Management',
                                url: `${params.catcoverageDomain}/admin_BAATermsManagement.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'baaAreaManagement',
                                label: 'Binding Authority Geographic Area Management',
                                url: `${params.catcoverageDomain}/admin_baa_area_management.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'bindingAuthorityManagement',
                                label: 'Binding Authority Management',
                                url: `${params.catcoverageDomain}/admin_bindingAuthority_management.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'fipsCounty',
                                label: 'County FIPS Management',
                                url: `${params.catcoverageDomain}/admin_fips_county.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'decisionEngine',
                                label: 'Decision Engine',
                                url: 'https://rules-ux.catcoverage.com/',
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'eligibilityMessagePriorities',
                                label: 'Eligibility Message Priorities',
                                url: `${params.rootUrl}${params.securedUrl}${params.adminUrl}/${AdminSectionName.ELIGIBILITY_MESSAGE_PRIORITIES}`,
                                isRouter: true,
                                adminSectionName: AdminSectionName.ELIGIBILITY_MESSAGE_PRIORITIES,
                                subLinks: []
                            },
                            {
                                id: 'environmentVariables',
                                label: 'Environment Variables',
                                url: `${params.catcoverageDomain}/admin_environmentVariables.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'femaDataManagement',
                                label: 'FEMA Data Management',
                                url: `${params.catcoverageDomain}/admin_FEMADataManagement.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'flaggedPolicies',
                                label: 'Flagged Policies',
                                url: `${params.catcoverageDomain}/admin_policies_flagged.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'manageHelp',
                                label: 'Manage User Help & Terms and Conditions',
                                url: `${params.catcoverageDomain}/admin_Manage_Help.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'minCostPerSquareFoot',
                                label: 'Minimum Cost Per Square Foot',
                                url: `${params.rootUrl}${params.securedUrl}${params.adminUrl}/${AdminSectionName.MINIMUM_COST_PER_SQUARE_FOOT}`,
                                isRouter: true,
                                adminSectionName: AdminSectionName.MINIMUM_COST_PER_SQUARE_FOOT,
                                subLinks: []
                            },
                            {
                                id: 'munichReTransactions',
                                label: 'Munich Re Transaction Batches',
                                url: `${params.catcoverageDomain}/admin_munichReTransactions.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'policyMap',
                                label: 'Policy Map',
                                url: `${params.catcoverageDomain}/policyMap.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'quoteBatch',
                                label: 'Quote Batch Upload',
                                url: `${params.catcoverageDomain}/admin_quoteBatch.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'quoteCompare',
                                label: 'Quote Compare Batch Upload',
                                url: `${params.catcoverageDomain}/admin_quoteCompare.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'ratesBoundsManagement',
                                label: 'Rates Bounds Management',
                                url: `${params.catcoverageDomain}/admin_rateBoundsManagement.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'ratingMethodsManagement',
                                label: 'Rating Methods Management',
                                url: `https://rate-ux-demo.catcoverage.com`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'regionalRateSurcharges',
                                label: 'Regional Rate Surcharges Management',
                                url: `${params.catcoverageDomain}/admin_regionalRateSurcharges.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'unpaidEndorsements',
                                label: 'Unpaid Endorsements',
                                url: `${params.catcoverageDomain}/admin_Unpaid_Endorsements.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'admin-claims',
                                label: 'Claims',
                                url: `${params.catcoverageDomain}/admin_claims.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'notice-queue',
                                label: 'Notices',
                                url: `${params.catcoverageDomain}/Admin/notice_queue.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'producers',
                                label: 'Producers',
                                url: `${params.catcoverageDomain}/admin_producers.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                            {
                                id: 'reports',
                                label: 'Reports',
                                url: `${params.catcoverageDomain}/underwriter_reports.aspx`,
                                isRouter: false,
                                subLinks: []
                            },
                        ]
                    }
                ]
            },
           
            {
                id: 'surplusLines-title',
                label: 'Surplus Lines',
                isRouter: false,
                subLinks: [
                    {
                        id: 'surplusBatches',
                        label: 'Surplus Lines Batches',
                        url: `${params.catcoverageDomain}/admin_accounting_surplusbatches.aspx`,
                        isRouter: false,
                        subLinks: []
                    },
                    {
                        id: 'manageDiligentDocuments',
                        label: 'Manage Diligent Documents',
                        url: `${params.catcoverageDomain}/admin_Manage_DiligentDocuments.aspx`,
                        isRouter: false,
                        subLinks: []
                    },
                    {
                        id: 'manageAffidavitDocuments',
                        label: 'Manage Affidavit Documents',
                        url: `${params.catcoverageDomain}/admin_Manage_AffadavitDocuments.aspx`,
                        isRouter: false,
                        subLinks: []
                    },
                    {
                        id: 'manageSurplusInstructions',
                        label: 'Manage Surplus Instructions',
                        url: `${params.catcoverageDomain}/admin_Manage_SurplusInstructions.aspx`,
                        isRouter: false,
                        subLinks: []
                    },
                ]
            },
        ]
    }

    export default AdminNavigationConfig;